export default "__VITE_ASSET__CQFZBvhD__"